import './loading.less'
import React from 'react'
import Lottie from 'react-lottie'
import vpbAnimated from '../../assets/animation/vpbloading_new.json'

export default function Loading({ inline, overlay }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: vpbAnimated,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid',
    },
  };
  return (
    <div className={'container'}>
      <div className={'loaderWrapper'}>
        <Lottie options={defaultOptions}
          height={90}
          width={90}
          speed={1}
        />
      </div>
    </div>
  );
}
